// src/services/menuService.ts
import {
  MenuItemType,
  OrganizedMenu,
  Restaurant,
  RestaurantMenu,
} from "../types/restaurant.types";
import { menu } from "../../../services/dummydata";
import { restaurantService } from "../../../services/restaurant.service";

export const organizeMenu = (menuItems: MenuItemType[]): OrganizedMenu => {
  return menuItems.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = {
        name: item.category,
        subCategories: {},
      };
    }

    if (!acc[item.category].subCategories[item.subCategory]) {
      acc[item.category].subCategories[item.subCategory] = {
        name: item.subCategory,
        isEnabled: true,
        items: [],
      };
    }

    acc[item.category].subCategories[item.subCategory].items.push(item);

    return acc;
  }, {} as OrganizedMenu);
};
